import React, { useEffect } from 'react';
import { connect, ConnectedProps } from '@cerebral/react';
import { state, sequences } from 'app/pwa/app.cerebral';
import { Title, Text, Button } from '../elements';
import Dropdown from './Dropdown';
import { useText } from 'common/hooks';

const deps = {
  campaign: state.account.joinCampaign.campaign,
  selections: state.account.joinCampaign.selections,
  isJoining: state.account.joinCampaign.isJoining,
  joinCampaignClicked: sequences`account.joinCampaign.joinCampaignSectionAndTeam`,
  optionSelected: sequences`account.joinCampaign.optionSelected`,
};

export function SectionAndTeam({
  campaign,
  selections,
  joinCampaignClicked,
  isJoining,
  optionSelected,
}: typeof deps & ConnectedProps): React.ReactElement {
  const t = useText();
  const sections = Object.assign(
    {},
    ...Object.entries(campaign.structure.sections).map(
      ([sectionKey, { name }]) => ({ [sectionKey]: name })
    )
  ) as { [key: string]: string };
  const multipleSections = Object.keys(sections).length > 1;

  useEffect(() => {
    if (Object.keys(sections).length === 1 && !selections.section) {
      optionSelected({
        key: Object.keys(sections)[0],
        text: Object.values(sections)[0],
        field: 'section',
      });
    }
  }, [sections]);

  const teams = selections.section
    ? (Object.assign(
        {},
        ...Object.entries(
          campaign.structure.sections[selections.section].teams
        ).map(([teamKey, { name }]) => ({ [teamKey]: name }))
      ) as { [key: string]: string })
    : {};

  return (
    <>
      <Title>
        {t('account.join_campaign.link.title', {
          campaignName: campaign.name,
          organisationName: campaign.organisation.name,
        })}
      </Title>
      <Text>
        {multipleSections
          ? t('account.join_campaign.link.sub_title', {
              sectionTerm:
                campaign.sectionTerm === 'other'
                  ? campaign.specifiedTerm
                  : t(
                      `campaign.section_terms.${
                        campaign.sectionTerm || 'section'
                      }`,
                      { smart_count: 1 }
                    ),
            })
          : t('account.join_campaign.link.sub_title_team_only')}
      </Text>
      {multipleSections ? (
        <Dropdown options={sections} level={'section'} />
      ) : null}
      {selections.section ? <Dropdown options={teams} level={'team'} /> : null}
      <Button
        disabled={!selections.section || !selections.team || isJoining}
        onClick={() => {
          joinCampaignClicked();
        }}
      >
        {t('account.join_campaign.form.save_and_continue')}
      </Button>
    </>
  );
}

export default connect(deps, SectionAndTeam);
